import React from 'react';
import { array } from 'prop-types';
import { Link } from 'react-router-dom';
import PixelListItem from './PixelListItem';
import { FormattedMessage } from 'react-intl';

const propTypes = {
  pixels: array.isRequired,
};
const defaultProps = {
  pixels: [],
};

const PixelListGroup = ({ pixels, isCdn, coins, id, withLink }) => (
  <ul className="pixels-list list-unstyled">
    {pixels.length > 0 &&
      pixels.map(pixel => (
        <PixelListItem key={pixel.id} pixel={pixel} isCdn={isCdn} coins={coins} />
      ))}
    {id && withLink && (
      <li key='pixel-request-link'>
        <Link to={`/tickets/create?theme=pixelRequest&offer=${id}`}>
          <FormattedMessage
            id="offer.buttons.pixels-request"
            defaultMessage="Did you find a higher payout?"
          />
        </Link>
      </li>
    )}
  </ul>
);

PixelListGroup.propTypes = propTypes;
PixelListGroup.defaultProps = defaultProps;

export default PixelListGroup;
